export const BACK_ROUTES_PATH = [
  { route: '/purchase/create/', route_to_redirect: '/purchase/list/' },
  {
    route: '/purchase/edit/',
    route_to_redirect: '/purchase/list/',
  },
  {
    route: '/purchase/return/create/',
    route_to_redirect: '/purchase/return/list/',
  },
  {
    route: '/purchase/return/edit/',
    route_to_redirect: '/purchase/return/list/',
  },
  {
    route: '/sales/create/',
    route_to_redirect: '/sales/list/',
  },
  {
    route: '/sales/edit/',
    route_to_redirect: '/sales/list/',
  },
  {
    route: '/sales/order/edit/',
    route_to_redirect: '/sales/order/list/',
  },
  {
    route: '/sales/return/edit/',
    route_to_redirect: '/sales/return/list/',
  },

  {
    route: '/sales/order/create/',
    route_to_redirect: '/sales/order/list/',
  },
  {
    route_to_redirect: '/sales/return/list/',
    route: '/sales/return/create/',
  },
  {
    route_to_redirect: '/issues/karigar/list/',
    route: '/issue/karigar/create/',
  },
  {
    route_to_redirect: '/issues/karigar/list/',
    route: '/issue/karigar/edit/',
  },
  {
    route_to_redirect: '/issues/refine/list/',
    route: '/issue/refine/create/',
  },
  {
    route_to_redirect: '/issues/refine/list/',
    route: '/issue/refine/edit/',
  },
  {
    route_to_redirect: '/issues/party/list/',
    route: '/issue/party/create/',
  },
  {
    route_to_redirect: '/issues/party/list/',
    route: '/issue/party/edit/',
  },
  {
    route_to_redirect: '/receives/karigar/list/',
    route: '/receive/karigar/create/',
  },
  {
    route_to_redirect: '/receives/karigar/list/',
    route: '/receive/karigar/edit/',
  },
  {
    route_to_redirect: '/receives/refine/list/',
    route: '/receive/refine/create/',
  },
  {
    route_to_redirect: '/receives/refine/list/',
    route: '/receive/refine/edit/',
  },

  {
    route_to_redirect: '/receives/party/list/',
    route: '/receive/party/create/',
  },
  {
    route_to_redirect: '/receives/party/list/',
    route: '/receive/party/edit/',
  },
  {
    route_to_redirect: '/opening/stock/list/',
    route: '/opening/stock/create/',
  },
  {
    route_to_redirect: '/opening/stock/list/',
    route: '/opening/stock/edit/',
  },
  {
    route_to_redirect: '/contra/voucher/list/',
    route: '/contra/voucher/create/',
  },
  {
    route_to_redirect: '/journal/voucher/list/',
    route: '/journal/voucher/create/',
  },
  {
    route_to_redirect: '/receipt/voucher/list/',
    route: '/receipt/voucher/create/',
  },
  {
    route_to_redirect: '/metal-to/cash/list/',
    route: '/metal-to/cash/create/',
  },
  {
    route_to_redirect: '/accounting/cash-to-metals/list/',
    route: '/metal-to/cash/create/',
  },
  {
    route_to_redirect: '/ledger/reports/',
    route: '/ledger-details/reports/',
  },

  {
    route_to_redirect: '/stock/detail/report/',
    route: '/stock/ledger/report/',
  },

  {
    route_to_redirect: '/stock-summary/reports/',
    route: '/stock/detail/report/',
  },
];
